













import { Component } from 'vue-property-decorator'
import { mixins } from 'nuxt-property-decorator'
import { Tab } from '../../product/OneProductDataContainer.vue'
import CurrentProductMixin from '~/mixins/CurrentProduct'

enum PRODUCT_DESCRIPTIONS {
  FULL_DESCRIPTION = 'FULL_DESCRIPTION',
  USAGE = 'USAGE',
  BRAND_DESCRIPTION = 'BRAND_DESCRIPTION'
}

@Component({
  components: {
    OneProductDescription: () => import('~/components/molecules/rows/OneProductDescription.vue'),
  },
})
export default class OneProductDescriptionSection extends mixins<CurrentProductMixin>(CurrentProductMixin) {
  PRODUCT_DESCRIPTIONS = PRODUCT_DESCRIPTIONS

  get productDescription(): string | null {
    return this.$product?.fullDescription || null
  }

  get brandDescription(): string | null {
    return this.$product?.brand?.description || null
  }

  get usageDescription(): string | null {
    return this.$product?.usage || null
  }

  get hasAnyDescriptions(): boolean {
    return !!this.productDescription || !!this.brandDescription || !!this.usageDescription
  }

  get descriptionTabs(): Array<Tab> {
    const descriptionTabs: Array<Tab> = []
    if (this.$product?.fullDescription) {
      descriptionTabs.push({
        name: this.$t('product_page.description') as string,
        slotName: PRODUCT_DESCRIPTIONS.FULL_DESCRIPTION,
      })
    }
    if (this.$product?.usage) {
      descriptionTabs.push({
        name: this.$t('product_page.usage') as string,
        slotName: PRODUCT_DESCRIPTIONS.USAGE,
      })
    }
    if (this.$product?.brand?.description) {
      descriptionTabs.push({
        name: this.$t('product_page.brand_description') as string,
        slotName: PRODUCT_DESCRIPTIONS.BRAND_DESCRIPTION,
      })
    }
    return descriptionTabs
  }
}
